/* eslint consistent-return: 0 */
import * as Yup from "yup";
import { I18n } from "aws-amplify";

import { validateCpf, validateCnpj } from "./validations";

export const getValidationSchemaByName = (name: any): any => {
  if (!Array.isArray(name)) {
    switch (name) {
      case "codeRequired":
        return Yup.number()
          .min(6, I18n.get("ValidateMinCode"))
          .required(I18n.get("ValidateRequiredField"));
      case "phoneNumberRequired":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .matches(
            /^\([1-9]\d\) \d{4,5}-\d{4}$/,
            "Telefone inválido. Ex: (99) 9999-9999",
          );
      case "inputRadioRequired":
        return Yup.string()
          .nullable()
          .required(I18n.get("ValidateRequiredField"));
      case "inputRequired":
        return Yup.string().required(I18n.get("ValidateRequiredField"));
      case "arrayRequired":
        return Yup.array().required(I18n.get("ValidateRequiredField"));
      case "emailRequired":
        return Yup.string()
          .email(I18n.get("ValidateInvalidEmail"))
          .required(I18n.get("ValidateRequiredField"));
      case "validEmail":
        return Yup.string().email(I18n.get("ValidateInvalidEmail"));
      case "passwordRequired":
        return Yup.string()
          .min(6, I18n.get("ValidateMinPassword"))
          .max(6, I18n.get("ValidateMaxCode"));
      // .required(I18n.get('ValidateRequiredField'))
      case "passwordWithMatches":
        return Yup.string()
          .min(8, "Senha precisa ter no mínimo 8 caracteres")
          .matches(/[0-9]/, "Senha precisa ter no mínimo um número")
          .matches(/[a-z]/, "Senha precisa ter no mínimo uma letra minúscula")
          .matches(/[A-Z]/, "Senha precisa ter no mínimo uma letra maiúscula")
          .matches(
            /[!@#$%*()_/\\\-+^&{}:;?.]/,
            "Senha precisa ter no mínimo um caractere especial",
          )
          .required("Senha é obrigatória");
      case "confirmPassword":
        return Yup.string().when("password", {
          is: (val: any) => val && val.length >= 6,
          then: Yup.string()
            .oneOf([Yup.ref("password")], I18n.get("ValidatePasswordNotEquals"))
            .required(I18n.get("ValidateRequiredField")),
        });
      case "inputRequiredCode":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .matches(/[0-9]/, I18n.get("ValidateOnlyNumbers"));
      case "isValidName":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .min(2, I18n.get("ValidateMinName"));
      case "cpfValidation":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .test("cpf-validation", I18n.get("ValidateInvalidCPF"), (value) =>
            validateCpf(value),
          );
      case "cpnjValidation":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .test("cnpj-validation", "CNPJ Inválido", (value) =>
            validateCnpj(value),
          );
      case "cpfValidationNotRequired":
        return Yup.string().test(
          "cpf-validation",
          I18n.get("ValidateInvalidCPF"),
          (value) => (value ? validateCpf(value) : true),
        );
      case "cnpjValidationNotRequired":
        return Yup.string().test("cnpj-validation", "CNPJ Inválido", (value) =>
          value ? validateCnpj(value) : true,
        );
      case "dateFromToday":
        return Yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .test(
            "date-from-today",
            "A data deve ser a partir de hoje",
            (value) => {
              if (!value) return false;
              const selectedDate = new Date(value);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              selectedDate.setHours(0, 0, 0, 0);
              return selectedDate >= today;
            },
          );
      case "dateFromTodayNotRequired":
        return Yup.string().test(
          "date-from-today",
          "A data deve ser a partir de hoje",
          (value) => {
            if (!value) return true;
            const selectedDate = new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            return selectedDate >= today;
          },
        );
      default:
        throw new Error(`Validation ${name} don't found`);
    }
  }

  return "maoe";
};
